import Main from './Main';

global.Main = Main;
